// extracted by mini-css-extract-plugin
export default {"wrapper":"M0-z","availablePromoMessagesLabel":"N0-z","promoMessageList":"O0-z","promoMessage":"P0-z","appliedPromoMessage":"Q0-z","promoMessageAmount":"R0-z"};